import {
  buildDynamicDataHelpLines,
  formatTokenHint,
  type CanonicalToken,
  type DynamicDataHelpLine,
  type SupportedLanguage,
} from '@shared/core/localized-defaults'

export type MessageTemplateFieldType = 'confirmation' | 'reminder' | 'follow_up'

const MESSAGE_TYPE_LABELS: Record<MessageTemplateFieldType, string> = {
  confirmation: 'confirmation',
  reminder: 'reminder',
  follow_up: 'follow-up',
}

const PLACEHOLDER_TOKENS: readonly CanonicalToken[] = [
  'from',
  'title',
  'date',
  'time',
  'location',
  'eventlocation',
  'videolink',
]

export const DYNAMIC_DATA_TOKEN_DESCRIPTION_MESSAGE_IDS: Record<CanonicalToken, string> = {
  title: 'configuration.step1.body.title',
  date: 'configuration.step1.body.date',
  time: 'configuration.step1.body.time',
  from: 'configuration.step1.body.from',
  location: 'configuration.step1.body.location',
  eventlocation: 'configuration.step1.body.eventlocation',
  videolink: 'configuration.step1.body.videolink',
}

export function getDynamicDataHelpLines(language: SupportedLanguage): DynamicDataHelpLine[] {
  return buildDynamicDataHelpLines(language)
}

export function buildMessageFieldPlaceholder(
  messageType: MessageTemplateFieldType,
  language: SupportedLanguage,
): string {
  const formattedTokens = PLACEHOLDER_TOKENS.map((token) => formatTokenHint(token, language))
  const tokenList =
    formattedTokens.length <= 1
      ? (formattedTokens[0] ?? '')
      : `${formattedTokens.slice(0, -1).join(', ')}, and ${formattedTokens[formattedTokens.length - 1]}`

  return `Craft your ${MESSAGE_TYPE_LABELS[messageType]} message here. You can use placeholders like ${tokenList} to automatically include event details.`
}
